import { useMemo } from 'react';
import { useStreamContext } from '../../../stream/context';
import { createFieldRecord } from '../../../utils/data';
/**
 * Provides fieldId. Composed with fieldName, fieldIndices and formName
 *
 * @documented
 * @import import useFieldId from '@gef-ui/form-core/hooks/field/useFieldId'
 * @param {Object} input
 * @param {String} input.fieldName
 * @param {Number[]} input.fieldIndices
 * @returns {String} fieldId
 * @example
 *
 * 	const fieldId = useFieldId({fieldName: 'xxx'});
 *
 */ const useFieldId = ({ fieldName, fieldIndices })=>{
    const { name } = useStreamContext();
    const fieldId = useMemo(()=>`${name}-${createFieldRecord(fieldName, fieldIndices)}`, [
        name,
        fieldName,
        fieldIndices
    ]);
    return fieldId;
};
export default useFieldId;
